import { UserSelTab } from "@jd/focus-desktop-comps/lib/es/UserSelection";

// 通讯录菜单标识
export enum AddressNavKey {
  DEFAULT = "default",
  NEW_CONTACTS = "new_contacts", // 新的联系人
  SPECIAL_PROJECTS = "special_projects", // 我的专班
  GROUP = "group", // 群组
  ORG = "org", // 组织架构
  VIRTUAL_ORG = "virtual_org", // 组织架构
  EXTERNAL_CONTACTS = "external_contacts", // 新的联系人
  ADD_EXTERNAL_CONTACTS_GROUP = "add_external_contacts_group", // 新的联系人
  MY_DEPARTMENT = "my_department", // 我的部门
  TAG = "tag",
  PUBLIC_ACCOUNT = "public_account",
  MANAGE_EXTERNAL = "manage_external",
  /** 订阅号 */
  SUB = "sub",
  /** 广播号 */
  BROADCAST = "broadcast",
  WORK_LINE = "work_line"
}

// 通讯录搜索类型
export enum AddressSearchKey {
  CONTACTS = "contacts",
  GROUP = "group"
}

export interface SearchResultModel {
  app: string;
  avatar: string | null;
  deptId: string | null;
  deptName: string | null;
  email: string | null;
  emplAccount: string;
  employeeId: string | null;
  mobile: string | null;
  realName: string;
  teamId: string;
  titleId: string | null;
  titleName: string | null;
  userCode: string | null;
  userId: string | null;
}

export const ZoomMeetingStatus = {
  MEETING_STATUS_IDLE: 0, // Idle status, no meeting running
  MEETING_STATUS_CONNECTING: 1, // Connecting meeting server status
  MEETING_STATUS_WAITINGFORHOST: 2, // Waiting for host to start meeting
  MEETING_STATUS_INMEETING: 3, // Meeting is ready, in meeting status
  MEETING_STATUS_DISCONNECTING: 4, // Disconnecting meeting server status
  MEETING_STATUS_RECONNECTING: 5, // Reconnecting meeting server status
  MEETING_STATUS_FAILED: 6, // Meeting connection error
  MEETING_STATUS_ENDED: 7, // Meeting is ended
  MEETING_STATUS_UNKNOW: 8,
  MEETING_STATUS_LOCKED: 9,
  MEETING_STATUS_UNLOCKED: 10,
  MEETING_STATUS_IN_WAITING_ROOM: 11,
  MEETING_STATUS_WEBINAR_PROMOTE: 12,
  MEETING_STATUS_WEBINAR_DEPROMOTE: 13,
  MEETING_STATUS_JOIN_BREAKOUT_ROOM: 14,
  MEETING_STATUS_LEAVE_BREAKOUT_ROOM: 15,
  MEETING_STATUS_AUDIO_READY: 16,
  MEETING_STATUS_OTHER_MEETING_INPROGRESS: 17,
  MEETING_STATUS_WAITING_EXTERNAL_SESSION_KEY: 18 // Waiting for the additional secret key
};

export enum ZoomSessionStateEnum {
  Call = 0, // 被叫
  Cancel = 1, // 呼叫方取消
  Ringing = 180, // 用户振铃 这个是反向发送消息
  UserReceive = 200, // 某个端用户接受了会邀
  UserReject = 486 // 某个端用户拒绝
}

// export interface IPermissions {
//     authorityType: number;
//     authorityTypeName: string;
//     resources: {
//         appId: string;
//         code: string;
//         desc: string;
//         name: string;
//         parentId: string;
//         resourceId: string;
//         url: string;
//     }[];
// }

export interface IPermissions {
  code: string;
  text: string;
}

export interface IClientConfig {
  [key: string]: 1 | 0 | undefined;
}

/**
 * 资源对应的id，用来判断权限
 */
export enum AuthorResourceEnum {
  VOIP = "audioVideo.initiateVoip",
  MEETING = "audioVideo.addMeeting", // 创建音视频权限
  MEETING_JOIN = "audioVideo.joinMeeting", // 参加音视频会议
  CREAT_LIVE_STREAM = "audioVideo.createLiveStream", // 创建直播会议
  ORG = "addressBook.readInstitution", // 通讯录组织架构
  MY_DEPARTMENT = "addressBook.readApartment", // 通讯录我的部门
  ADD_CONTACTS = "addressBook.addContact", // 搜索添加联系人
  CREAT_GROUP = "group.addGroup", // 创建群组
  CREAT_SCHREDULE = "calendar.addCalendarSchedule", // 新建日程
  CREAT_TASK = "task.addTask", // 新建任务
  CREAT_URGING = "fckAeBz1lGcQ7zRz1Atn", // 新建催办
  CREAT_DOCUMENT = "document.addDoc", // 新建文档
  EXPORT_DOCUMENT = "document.exportDoc", // 导出文档
  SEARCH_DEPARTMENT = "search.searchDepart", // 搜索.搜索支持部门
  // VOIP = 'ylQGvzLFBqGqnK8gJUsm',
  // MEETING = 'giYdL5q4pDPYxR2bd7kW',
  // MEETING_JOIN = 'EgERRhFrYRbUUTcsiibf', // 参加音视频会议
  // ORG = 'AvrtZko8l9DX7tPu9gr7', // 组织架构通讯录
  // MY_DEPARTMENT = '31LaIOVsxsxQ0HNZeoyA', // 我的部门
  // ADD_CONTACTS = 'NY1fqiQySrJQJFK7tuxs', // 搜索添加联系人
  // CREAT_GROUP = 'dbtc0niuZWiWIJSYcPLz', // 创建群组
  // CREAT_SCHREDULE = 'oOuXmoQ5dvyyCzzjw4pL', // 新建日程
  // CREAT_TASK = '6qB0Yxd9BDjcrxNAI3RH', // 新建任务
  // CREAT_URGING = 'fckAeBz1lGcQ7zRz1Atn', // 新建催办
  // CREAT_DOCUMENT = 'IgOIHUrIKMzQeYnYdYsS', // 新建文档
  // EXPORT_DOCUMENT = 'SyxNs9cPhkE9kRlVRrUk', // 导出文档
  JD_VIDEO = "audioVideo.jdVideo", // 音视频.单聊、群聊和个人详情页中用户优先使用京东视频会议
  EVENTTRACKING_START_UPLOAD = "eventTracking.startUploading" // 埋点.埋点启动上传
}

/**
 * 会议查询类型
 */
export enum MeetingQueryType {
  ONGOING = "ONGOING",
  UPCOMING = "UPCOMING",
  ONGOING_AND_UPCOMING = "ONGOING_AND_UPCOMING",
  CLOSED = "CLOSED"
}

export enum MeetingPlatform {
  ALL = "ALL", // 查询全部
  CLOUD_UNION = "CLOUD_UNION", // // 云联
  HW = "HW", // 华为音视频
  XYLINK = "XY_LINK", // 小鱼会议
  JBRTC = "JDTC" // 京东会议
}

export const MeetingPlatformName = {
  CLOUD_UNION: "视频会议", // // 云联
  HW: "信创视频会议", // 华为音视频
  XY_LINK: "政务视频会议", // 小鱼会议
  JDTC: "智能会议" // 京东会议
};

export interface DynamicObject {
  [key: string]: any;
}

/**
 * 人员选择器自定义排序
 * 1常用联系人 2组织架构 3工作条线 4我的联系人 5我的组
 */
export const userSelectionTabSort = [
  {
    tab: UserSelTab.recent,
    sort: 1
  },
  {
    tab: UserSelTab.org,
    sort: 2
  },
  {
    tab: UserSelTab.workLine,
    sort: 3
  },
  {
    tab: UserSelTab.externalContacts,
    sort: 4
  },
  {
    tab: UserSelTab.group,
    sort: 5
  }
];

/**
 * 人员选择器自定义排序
 * 1当前组成员 2常用联系人 3组织架构 4工作条线 5我的联系人 6我的组
 */
export const userSelectionBusinessTabSort = [
  {
    tab: UserSelTab.business,
    sort: 1
  },
  {
    tab: UserSelTab.recent,
    sort: 2
  },
  {
    tab: UserSelTab.org,
    sort: 3
  },
  {
    tab: UserSelTab.workLine,
    sort: 4
  },
  {
    tab: UserSelTab.externalContacts,
    sort: 5
  },
  {
    tab: UserSelTab.group,
    sort: 6
  }
];

export const MeetingConfig = [
  {
    platform: MeetingPlatform.CLOUD_UNION,
    label: "视频会议",
    desc: "支持：Win端，MacOS端，IOS端，安卓端"
  },
  {
    platform: MeetingPlatform.JBRTC,
    label: "智能会议",
    desc: "支持:网页端，信创端，Win端，MacOS端，IOS端，安卓端"
  },
  {
    platform: MeetingPlatform.XYLINK,
    label: "政务视频会议",
    desc: "支持:信创端，Win端，IOS端，安卓端，鸿蒙端"
  },
  {
    platform: MeetingPlatform.HW,
    label: "信创视频会议",
    desc: "支持:Win端"
  }
];
export enum UpgradePopType {
  NONE = 0,
  POPTIP = 1,
  REDDOT = 2,
  NOTIP = 3
}

// 应用场景类型
export enum ThirdAppSceneType {
  WORKPLACE = 1,
  NAVBAR = 2,
  CUSTOM_WORKPLACE = 3
}

// 打开方式，1=工作台打开，2=框架内打开，3=内置浏览器打开
// 应用打开类型
export enum ThirdAppOpenType {
  WORKPLACE = 1,
  INNER_FRAME = 2,
  INNER_BROWSER = 3,
  WEB_BROWSER = 4
}
